import React, { createContext, useContext } from 'react';

const OrderContext = createContext({
  number: '',
  store: '',
  language: '',
  appID: '',
  locationID: '',
  recaptchaKey: '',
  trackingData: {},
});

/*
  Custom hook to extract order details

  Usage:
    const orderDetails = useOrderDetails();
    language = orderDetails.language;
    store = orderDetails.store;
    orderNumber = orderDetails.Number;
 */
const useOrderDetails = () => {
  return useContext(OrderContext);
};

/*
  Provides a component that wraps your app with
  details about an order
 */
const OrderDetails = (props) => {
  const values = {
    number: props.orderNumber,
    language: props.languageCode,
    store: props.storeCode,
    appID: props.applicationId,
    locationID: props.locationId,
    recaptchaKey: props.recaptchaKey,
    trackingData: props.trackingData,
  };

  return (
    <OrderContext.Provider value={values}>
      {props.children}
    </OrderContext.Provider>
  );
};

export { OrderDetails, useOrderDetails };
